import { Time } from '@angular/common';
import Model from 'src/app/common/model';
import TreatmentTypeModel from './treatmentType.model';
import ItemMasterModel from './itemMaster.model';
import FarmSiteModel from './farmSite.model';

export default class TreatmentLogModel extends Model {
  treatmentType: TreatmentTypeModel;
  time: Time;
  itemMaster: ItemMasterModel; // MMS
  FarmSiteDetails: FarmSiteModel; // TC
  itemUom?: Array<ItemUOM>;
  treatment_type_id: number;
  person_id?: string;
  farm_site_id?: string;
  pond_id: number;
  pond_culture_id?: number;
  date: Date;
  doc: number;
  description?: string;
  quantity: number;
  uom: string;
  recommendation?: Text;
  treatment_item_id?: number;
  isPreparatory: boolean;
  section_name: string;
  pond_name: string;
  displaytime: string;
  othername: string;
  treatment_type: string;
  business_id?: string;
  item?: string;
  isManualUOM?: boolean;
  item_id?: number;
  uom_id?: number;
  name?: string;
  location_tracker_id: string;

  constructor() {
    super();
    this.itemUom = new Array();
  }
}

//////////////////////////////
//ItemUOM
//////////////////////////////
export class ItemUOM {
  id?: number;
  name?: string;
  uomadded?: boolean;

  constructor() { }
}

//////////////////////////////
//BrandingAttachments
//////////////////////////////
export class BrandingAttachments {
  file_path?: string;
  file_type: string;
  data: string;

  constructor() {
  }
}

